<template>
  <el-dialog title="审核信息" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
    <el-form ref="form" :model="auditInfo" label-width="100px">
      <el-form-item label="审核状态" prop="state">
        <el-select v-model="auditInfo.state" placeholder="请审核" style="width:100%">
          <el-option label="同意" value="1100" />
          <el-option label="拒绝" value="1200" />
        </el-select>
      </el-form-item>
      <el-form-item label="原因" prop="remark">
        <el-input v-model="auditInfo.remark" type="textarea" placeholder="必填，请填写原因" :rows="4" maxlength="200"
          show-word-limit />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="_auditSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'Audit',
  data() {
    return {
      dialogVisible: false,
      auditInfo: {
        state: '',
        remark: ''
      }
    }
  },
  watch: {
    'auditInfo.state'(val) {
      if (val === '1100') {
        this.auditInfo.remark = '同意'
      } else if (val === '1200') {
        this.auditInfo.remark = ''
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.clearAuditInfo()
    },
    handleClose() {
      this.dialogVisible = false
      this.clearAuditInfo()
    },
    auditValidate() {
      if (!this.auditInfo.state) {
        this.$message.error('审核状态不能为空')
        return false
      }
      if (!this.auditInfo.remark) {
        this.$message.error('原因内容不能为空')
        return false
      }
      if (this.auditInfo.remark.length > 200) {
        this.$message.error('原因内容不能超过200字')
        return false
      }
      return true
    },
    _auditSubmit() {
      if (!this.auditValidate()) return

      this.$emit('auditNotify', {
        state: this.auditInfo.state,
        remark: this.auditInfo.remark
      })
      this.handleClose()
    },
    clearAuditInfo() {
      this.auditInfo = {
        state: '',
        remark: ''
      }
    }
  }
}
</script>